export default __webpack_public_path__ + "static/media/logo.afc55c70.svg";